import { PodConfigurationModel } from './../../../app/services/api/podClient';
import { ConfigurationLevel } from '../enums/ConfigurationLevel';

export type ConfigurationCascadeOperations = {
  toCreate: PodConfigurationModel[];
  toUpdate: PodConfigurationModel[];
};

/** Builds item configuration changes required when a store-level POD switch changes. */
export const buildStoreCascadeOps = (
  storeConfig: PodConfigurationModel,
  allStoreItemConfigs: PodConfigurationModel[],
  franchiseConfigurations: PodConfigurationModel[],
  franchiseName?: string,
): ConfigurationCascadeOperations => {
  const toCreate: PodConfigurationModel[] = [];
  const toUpdate: PodConfigurationModel[] = [];
  const targetFranchise = franchiseName ?? storeConfig.franchiseName;
  const storeItemConfigs = allStoreItemConfigs.filter(c =>
    c.storeNumber === storeConfig.storeNumber &&
    Boolean(c.itemNumber) &&
    c.franchiseName === targetFranchise,
  );

  // The parent store switch is the gate. Do not rewrite existing child-item Enabled values here:
  // they are item-specific user choices and must survive a store OFF -> ON cycle unchanged.
  // When a store is enabled, only create currently enabled franchise items that genuinely have no
  // store row yet. POD's publisher repairs/recalculates the enabled child rows after parent enable.
  if (storeConfig.enabled) {
    const enabledFranchiseConfigs = franchiseConfigurations.filter(c =>
      Boolean(c.itemNumber) &&
      c.enabled &&
      !c.storeNumber &&
      c.franchiseName === targetFranchise,
    );
    const existingItemNumbers = new Set(storeItemConfigs.map(c => c.itemNumber));

    enabledFranchiseConfigs
      .filter(config => !existingItemNumbers.has(config.itemNumber))
      .forEach(config => toCreate.push({
        ...config,
        id: 0,
        configurationLevel: ConfigurationLevel.Store,
        storeNumber: storeConfig.storeNumber,
        storeName: storeConfig.storeName,
        starbucksStoreNumber: storeConfig.starbucksStoreNumber,
      }));
  }

  return { toCreate, toUpdate };
};
